import collect from 'collect.js';
import { OrderData, ProfileInterface } from '../exports/Interfaces';

/**
 * The order fields a profile can pre-fill, with every empty value dropped.
 *
 * A profile is merged into `cached_order` on login and after every profile update. A guest who
 * entered a delivery address and then logs in at the cart gets a brand-new account whose
 * `delivery_*` columns are all null; spreading that profile as-is erased the address they had
 * just typed while `method` and `delivery_zone` survived, so checkout hit a 422 on the four
 * address fields (Pizza Bulls, 2026-09-29). Only values the profile actually holds are copied.
 *
 * `customer_note` is left out: it is the note saved from the last delivery order, and checkout
 * offers it on delivery only (see OrderInfo).
 */
export function profileOrderFields(profile: ProfileInterface): Partial<OrderData> {
  return collect({
    customer_phone_number: profile.phone_number,
    customer_email: profile.email,
    customer_first_name: profile.first_name,
    customer_last_name: profile.last_name,
    delivery_street_name: profile.delivery_street_name,
    delivery_street_number: profile.delivery_street_number,
    delivery_city: profile.delivery_city,
    delivery_state: profile.delivery_state,
    delivery_country: profile.delivery_country,
    delivery_zip_code: profile.delivery_zip_code,
    delivery_lat: profile.delivery_lat,
    delivery_lng: profile.delivery_lng,
    delivery_dropoff_action: profile.delivery_dropoff_action,
    delivery_doorbell_name: profile.delivery_doorbell_name,
    delivery_company_name: profile.delivery_company_name,
  })
    .filter((value) => value !== null && value !== undefined && value !== '')
    .all() as Partial<OrderData>;
}
